import { useOutletContext, Link } from "react-router-dom";
import SEO from "../components/SEO";
import SearchWidget from "../components/SearchWidget";
import Reveal from "../components/Reveal";
import { t } from "../i18n";
import { cities, pagePath, staticPath } from "../data";
import { ChevronRight } from "lucide-react";

export default function DealsPage() {
  const { lang } = useOutletContext();
  const i = t[lang];
  const title = lang === "it" ? "Offerte noleggio auto — Ricerca live | BoingCars" : "Car Rental Deals — Live Search | BoingCars";

  return (
    <>
      <SEO lang={lang} title={title} description={i.deals.sub} pathEn={staticPath("en", "deals")} pathIt={staticPath("it", "deals")} />
      <section className="container-site py-16 md:py-24" data-testid="deals-page">
        <Reveal>
          <h1 className="max-w-2xl font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">
            {i.home.dealsTitle}
          </h1>
          <p className="mt-5 max-w-xl text-base text-muted-foreground md:text-lg">{i.deals.sub}</p>
        </Reveal>
        <Reveal delay={0.1} className="mt-12">
          <div className="rounded-3xl bg-white p-4 shadow-xl ring-1 ring-black/5 sm:p-6">
            <SearchWidget lang={lang} channel="deals" />
          </div>
        </Reveal>
        <Reveal className="mt-16">
          <h2 className="font-display text-2xl font-extrabold tracking-tighter sm:text-3xl">{i.deals.popular}</h2>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {cities.map((c) => (
              <li key={c.id}>
                <Link
                  to={pagePath(lang, c)}
                  data-testid={`deals-link-${c.id}`}
                  className="flex items-center justify-between rounded-xl border border-border bg-white px-5 py-4 text-sm font-semibold transition-colors duration-200 hover:border-petrol hover:text-petrol"
                >
                  {c.name[lang]}
                  <ChevronRight className="h-4 w-4 text-ember" aria-hidden="true" />
                </Link>
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal className="mt-10 text-xs text-muted-foreground">{i.common.affiliateNote}</Reveal>
      </section>
    </>
  );
}
